import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { responseLogWithNotification } from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import {
  dateFormatter, infoFormatterIntl, localeFormatter, userShortFIOFormatter,
} from '../../../utils/formatters';
import { getProfileData } from '../../Authorized/reducer';
import { loadRepresentativeById } from '../../Authorized/actions';

export default function RepresentativeDetailsPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    loadingCreateRepresentative,
    representative,
  } = useSelector(getProfileData);

  const {
    name_for_applicant,
    created_at,
    validity_period,
    status,
    user,
    type = {},
    is_applicant_approved,
    is_user_approved,
    is_permanent,
    user_approved_at,
    applicant_approved_at,
  } = representative;

  useEffect(() => {
    dispatch(loadRepresentativeById(id)).catch(responseLogWithNotification);
  }, []);

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <Loader loading={loadingCreateRepresentative} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'representative.details.invite' })}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.REPRESENTATIVE_DETAIL, id })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.name_for_applicant', name_for_applicant, {}, 'brand')}
          {infoFormatterIntl('representative.created_at', dateFormatter(created_at), {}, 'model')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.validity_period', is_permanent ? 'Постоянная' : dateFormatter(validity_period), {}, 'inn')}
          {infoFormatterIntl('representative.status', localeFormatter('representative.status', status), {}, 'ogrn')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.user_id', userShortFIOFormatter(user), {}, 'vehicle_vin')}
          {infoFormatterIntl('representative.type', type === 'invite' ? 'Приглашение' : 'Довереность', {}, 'registry_vehicle.number')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('representative.is_applicant_approved', is_applicant_approved ? dateFormatter(applicant_approved_at) : 'Нет', {}, 'updated_at')}
          {infoFormatterIntl('representative.is_user_approved', is_user_approved ? dateFormatter(user_approved_at) : 'Нет', {}, 'registry_vehicle.vehicle_year')}
        </Row>
      </div>
    </div>
  );
}
